import { api } from './api';
import { User } from '../types/user';

/**
 * Get all users (admin only)
 */
export const fetchUsers = async (): Promise<User[]> => {
  try {
    const response = await api.get<User[]>('/api/user');
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    return [];
  }
};

/**
 * Get current user
 */
export const fetchCurrentUser = async (): Promise<User | null> => {
  try {
    const response = await api.get<User>('/api/user/me');
    return response.data;
  } catch (error) {
    console.error('Error fetching current user:', error);
    return null;
  }
};

/**
 * Get user by ID (admin only)
 */
export const fetchUserById = async (userId: string): Promise<User | null> => {
  try {
    const response = await api.get<User>(`/api/user/${userId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching user ${userId}:`, error);
    return null;
  }
};

/**
 * Update current user
 */
export const updateCurrentUser = async (userData: Partial<User>): Promise<User | null> => {
  try {
    const response = await api.put<User>('/api/user/me', userData);
    return response.data;
  } catch (error) {
    console.error('Error updating user:', error);
    return null;
  }
};

/**
 * Update user by ID (admin only)
 */
export const updateUser = async (userId: string, userData: Partial<User>): Promise<User | null> => {
  try {
    const response = await api.put<User>(`/api/user/${userId}`, userData);
    return response.data;
  } catch (error) {
    console.error(`Error updating user ${userId}:`, error);
    return null;
  }
}; 